// extracted by mini-css-extract-plugin
module.exports = {"warehousesPage":"Warehouses_warehousesPage__1WFHF","warehousesList":"Warehouses_warehousesList__3KqLc","actionButtonsContainer":"Warehouses_actionButtonsContainer__1eLFn"};